import React, { createContext, useContext, useState, useCallback } from 'react';

const PrivacyContext = createContext();

export const usePrivacy = () => {
  const context = useContext(PrivacyContext);
  if (!context) {
    throw new Error('usePrivacy must be used within a PrivacyProvider');
  }
  return context;
};

export const PrivacyProvider = ({ children }) => {
  const [isPrivacyModeEnabled, setIsPrivacyModeEnabled] = useState(false);

  const togglePrivacyMode = useCallback(() => {
    setIsPrivacyModeEnabled(prev => !prev);
  }, []);

  const enablePrivacyMode = useCallback(() => {
    setIsPrivacyModeEnabled(true);
  }, []);

  const disablePrivacyMode = useCallback(() => {
    setIsPrivacyModeEnabled(false);
  }, []);

  const value = {
    isPrivacyModeEnabled,
    togglePrivacyMode,
    enablePrivacyMode,
    disablePrivacyMode,
  };

  return (
    <PrivacyContext.Provider value={value}>
      {children}
    </PrivacyContext.Provider>
  );
};